// ReportDataForCompletedPigRunRequest.
//
// Class representing a report data request for a completed pig run.
export class ReportDataForCompletedPigRunRequest {
  public descending: boolean;
  public includeVerifiedPassagesOnly: boolean;
  public page: number;
  public rowsPerPage: number;
  public pigRunId: number;
  public sortBy: string;
  // EN-11: optional filters. Dates are UTC and are clamped to the run's
  // launch/receive window by the server; the marker must belong to the run.
  public startDate?: Date;
  public endDate?: Date;
  public pipelineSectionMarkerId?: number;

  public constructor(pigRunId: number) {
    this.pigRunId = pigRunId;
    this.includeVerifiedPassagesOnly = false;
    this.page = -1;
    this.rowsPerPage = -1;
    this.sortBy = '';
    this.descending = false;
  }
}
